import CheckmarkCircle from '../../src/legacy/CheckmarkCircle';
export default CheckmarkCircle;
